import { FC } from 'react'
import {
	RNProfile,
	RNLogin,
	RNLogout,
	RNWelcome,
	RNHome,
	RNRelay,
	RNChecks,
	RNChecksMechanic,
	RNChecksElectric,
	RNUsers,
	RNMechanic,
	RNElectric,
	RNJournal,
	RNCreateRelayType,
	RNCreateRelay,
	RNCreateRelayOne,
	RNRelayType,
	RNRelayOneCharacteristic,
	RNRelayOneRecords,
	RNCreateRelayOneRecord,
	RNLearning,
	RNLearningFavorites,
	RNLearningAdmin
} from './helpers/routeNames'
import Test from './pages/Test'
import Login from './pages/Login'
import Logout from './pages/Logout'
import Profile from './pages/Profile'
import Welcome from './pages/Welcome'
import { Home } from './pages/Home'
import { Relay } from './pages/Relay'
import { Checks } from './pages/Checks'
import { ChecksMechanic } from './pages/ChecksMechanic'
import { ChecksElectric } from './pages/ChecksElectric'
import { Users } from './pages/Users'
import { Mechanic } from './pages/Mechanic'
import { Electric } from './pages/Electric'
import { WorkerHome } from './pages/WorkerHome'
import { CreateRelayType } from './pages/CreateRelayType'
import { CreateRelay } from './pages/CreateRelay'
import { CreateRelayOne } from './pages/CreateRelayOne'
import { MechanicValue } from './pages/MechanicValue'
import { RelayType } from './pages/worker/RelayType'
import { RelayTypeOne } from './pages/worker/RelayTypeOne'
import { RelayW } from './pages/worker/RelayW'
import { RelayOneCharacters } from './pages/worker/RelayOne'
import { ElectricValue } from './pages/ElectricValue'
import { RelayRecords } from './pages/worker/RelayRecords'
import { RelayRecord } from './pages/worker/RelayRecordOne'
import { CreateRelayOneRecord } from './pages/worker/CreateRelayOneRecord'
import { Journal } from './pages/Journal'
import { Learning } from './pages/Learning'
import { LearningDetail } from './pages/LearningDetail'
import { LearningFavorites } from './pages/LearningFavorites'
import { LearningAdmin } from './pages/LearningAdmin'

export interface IElementProps {}

interface Route {
	path: string
	Element: FC<IElementProps>
}

export const WorkerRoutes: Route[] = [
	{
		path: RNWelcome,
		Element: Welcome
	},
	{
		path: RNHome,
		Element: WorkerHome
	},
	{
		path: RNJournal,
		Element: RelayType
	},
	{
		path: RNJournal + '/:relayTypeId',
		Element: Journal
	},
	{
		path: RNRelayType,
		Element: RelayType
	},
	{
		path: RNRelayType + '/:relayTypeId',
		Element: RelayTypeOne
	},
	{
		path: RNRelay + '/:relayId',
		Element: RelayW
	},
	{
		path: RNRelayOneCharacteristic + '/:relayTypeId/:relayId',
		Element: RelayOneCharacters
	},
	{
		path:
			RNRelayOneRecords + '/:relayTypeId/:relayId/:relayOneId',
		Element: RelayRecords
	},
	{
		path:
			RNRelayOneRecords +
			'/:relayTypeId/:relayId/:relayOneId/:recordId',
		Element: RelayRecord
	},
	{
		path: RNCreateRelayOne + '/:relayTypeId/:relayId',
		Element: CreateRelayOne
	},
	{
		path:
			RNCreateRelayOneRecord +
			'/:relayTypeId/:relayId/:relayOneId',
		Element: CreateRelayOneRecord
	},
	{
		path:
			RNMechanic +
			'/:relayTypeId/:relayId/:relayOneId/:recordId',
		Element: MechanicValue
	},
	{
		path:
			RNElectric +
			'/:relayTypeId/:relayId/:relayOneId/:recordId',
		Element: ElectricValue
	},
	{
		path: RNChecks,
		Element: RelayType
	},
	{
		path: RNLearning,
		Element: Learning
	},
	{
		path: RNLearningFavorites,
		Element: LearningFavorites
	},
	{
		path: RNLearning + '/:id',
		Element: LearningDetail
	},
	{
		path: RNProfile,
		Element: Profile
	},
	{
		path: '*',
		Element: Test
	},
	{
		path: RNLogout,
		Element: Logout
	}
]

export const Routes: Route[] = [
	{
		path: RNWelcome,
		Element: Welcome
	},
	{
		path: RNHome,
		Element: Home
	},
	{
		path: RNRelayType,
		Element: RelayType
	},
	{
		path: RNRelayType + '/:relayTypeId',
		Element: RelayTypeOne
	},
	{
		path: RNRelay + '/:relayId',
		Element: RelayW
	},
	{
		path: RNCreateRelayType,
		Element: CreateRelayType
	},
	{
		path: RNCreateRelay + '/:relayTypeId',
		Element: CreateRelay
	},
	{
		path: RNCreateRelayOne + '/:relayTypeId/:relayId',
		Element: CreateRelayOne
	},
	{
		path: RNMechanic + '/:relayTypeId',
		Element: Mechanic
	},
	{
		path: RNElectric + '/:relayTypeId',
		Element: Electric
	},
	{
		path: RNRelay,
		Element: Relay
	},
	{
		path: RNChecks,
		Element: Checks
	},
	{
		path: RNChecksMechanic,
		Element: ChecksMechanic
	},
	{
		path: RNChecksElectric,
		Element: ChecksElectric
	},
	{
		path: RNJournal,
		Element: RelayType
	},
	{
		path: RNJournal + '/:relayTypeId',
		Element: Journal
	},
	{
		path: RNRelayOneRecords + '/:relayTypeId/:relayId/:relayOneId',
		Element: RelayRecords
	},
	{
		path:
			RNRelayOneRecords +
			'/:relayTypeId/:relayId/:relayOneId/:recordId',
		Element: RelayRecord
	},
	{
		path: RNUsers,
		Element: Users
	},
	{
		path: RNLearning,
		Element: Learning
	},
	{
		path: RNLearningFavorites,
		Element: LearningFavorites
	},
	{
		path: RNLearningAdmin,
		Element: LearningAdmin
	},
	{
		path: RNLearning + '/:id',
		Element: LearningDetail
	},
	{
		path: RNProfile,
		Element: Profile
	},
	{
		path: '*',
		Element: Test
	},
	{
		path: RNLogout,
		Element: Logout
	}
]

export const loginRoutes: Route[] = [
	{
		path: RNLogin,
		Element: Login
	},
	{
		path: '*',
		Element: Test
	}
]
